import ModalWrapper, { IModalWrapperButtonProps } from '../../ModalWrapper';
import { useTranslation } from 'react-i18next';
import Text, { TEXT_COLOR, TEXT_TYPE, TEXT_WEIGHT } from 'component/atoms/typographie/Text';
import ModalContext from 'core/context/modal.context';
import { useContext, useEffect } from 'react';
import { MODAL_IDENTIFIER } from 'core/enum/modals.enum';
import LOCAL_STORAGE_KEYS from 'core/enum/local-storage.enum';
import { USER_TYPE } from '@wohnsinn/ws-ts-lib';
import UserContext from 'core/context/user.context';
import { wohnsinnServices } from 'App';
import SnackBarContext from 'core/context/snackbar.context';
import { getTenantApplicationState, TENANT_APPLICATION_STATE } from 'core/helper/get-tenant-application-state';

const EmailVerificationModal = () => {
  const { openModal, closeModal } = useContext(ModalContext);
  const { firebaseAuthService } = wohnsinnServices;
  const { user, activeUserType, landlordProfile, tenantProfile } = useContext(UserContext);
  const { handleSnackBar } = useContext(SnackBarContext);
  const { t } = useTranslation('common');
  const { t: m } = useTranslation('common', { keyPrefix: 'component.molecules.modals.signIn.EmailVerificationModal' });
  const email = localStorage.getItem('userC');

  const handleSubmit = async () => {
    const userType: USER_TYPE = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TYPE) as USER_TYPE;

    if (
      userType === USER_TYPE.LANDLORD ||
      getTenantApplicationState(tenantProfile) === TENANT_APPLICATION_STATE.COMPLETE
    ) {
      closeModal();
    } else {
      openModal({ id: MODAL_IDENTIFIER.COMPLETE_APPLICATION_FOLDER });
    }
  };

  const resendVerificationMail = async (): Promise<void> => {
    const email: string = activeUserType === USER_TYPE.LANDLORD ? landlordProfile.email : tenantProfile.email;
    try {
      await firebaseAuthService.triggerSendVerificationLink(email, activeUserType);
      handleSnackBar('toast.resendEmailVerificationMail', 'success');
    } catch (e) {
      console.error('Error on resendVerificationMail', e);
    }
  };

  useEffect(() => {
    if (user?.isEmailVerified) {
      handleSubmit();
    }
  }, [user]);

  const MODAL_BUTTONS: IModalWrapperButtonProps = {
    primary: {
      onClick: handleSubmit,
      buttonText: t('skip'),
    },
  };

  return (
    <ModalWrapper title={m('title')} icon={t('pictogram.mail')} buttons={MODAL_BUTTONS}>
      <Text align={'center'}>{m('text', { replace: { email } })}</Text>
      <Text type={TEXT_TYPE.TEXT_TYPE_CAPTION} weight={TEXT_WEIGHT.TEXT_WEIGHT_BOLD} align={'center'}>
        {m('subText')}
        <button onClick={resendVerificationMail}>
          <Text
            color={TEXT_COLOR.TEXT_COLOR_PRIMARY}
            type={TEXT_TYPE.TEXT_TYPE_CAPTION}
            weight={TEXT_WEIGHT.TEXT_WEIGHT_BOLD}
          >
            {m('sendNew')}
          </Text>
        </button>
      </Text>
    </ModalWrapper>
  );
};

export default EmailVerificationModal;
